import { Category } from '../../models/interfaces/category.interface';

const now = new Date();

export const categoriesMock: Category[] = [
  {
    id: 'category1',
    isActive: true,
    tenantId: 'tenant1',
    name: 'Liderança e Gestão',
    description: 'Categoria para liderança e planejamento.',
    color: '#5B55FF',
    createdAt: now,
    updatedAt: now
  },
  {
    id: 'category2',
    isActive: true,
    tenantId: 'tenant1',
    name: 'Desenvolvimento Pessoal',
    description: 'Cursos para crescimento individual.',
    color: '#7A55FF',
    createdAt: now,
    updatedAt: now
  },
  {
    id: 'category3',
    isActive: true,
    tenantId: 'tenant1',
    name: 'Comunicação Eficaz',
    description: 'Aprenda técnicas de comunicação profissional.',
    color: '#9555FF',
    createdAt: now,
    updatedAt: now
  },
  {
    id: 'category4',
    isActive: true,
    tenantId: 'tenant1',
    name: 'Inovação e Criatividade',
    description: 'étodos para inovar e resolver problemas.',
    color: '#B455F4',
    createdAt: now,
    updatedAt: now
  },
  {
    id: 'category5',
    isActive: true,
    tenantId: 'tenant1',
    name: 'Tecnologia e Ferramentas',
    description: 'Ferramentas digitais para produtividade.',
    color: '#F54297',
    createdAt: now,
    updatedAt: now
  },
  {
    id: 'category6',
    isActive: true,
    tenantId: 'tenant1',
    name: 'Gestão de Projetos',
    description: 'Boas práticas de execução e acompanhamento.',
    color: '#FF5B7B',
    createdAt: now,
    updatedAt: now
  },
  {
    id: 'category7',
    isActive: true,
    tenantId: 'tenant1',
    name: 'Liderança Transformacional',
    description: 'Evolua a liderança de equipes de alta performance.',
    color: '#FF7A45',
    createdAt: now,
    updatedAt: now
  },
  {
    id: 'category8',
    isActive: true,
    tenantId: 'tenant1',
    name: 'Marketing Digital',
    description: 'Estratégias e canais para ampliação de alcance.',
    color: '#FFAD33',
    createdAt: now,
    updatedAt: now
  },
  {
    id: 'category9',
    isActive: true,
    tenantId: 'tenant1',
    name: 'Inteligência Emocional',
    description: 'Desenvolva habilidades emocionais no trabalho.',
    color: '#F5D43D',
    createdAt: now,
    updatedAt: now
  },
  {
    id: 'category10',
    isActive: true,
    tenantId: 'tenant1',  
    name: 'Gestão do Tempo',
    description: 'Métodos para melhorar foco e entrega.',
    color: '#36CFC9',
    createdAt: now,
    updatedAt: now
  },
  {
    id: 'category11',
    isActive: true,
    tenantId: 'tenant1',
    name: 'Networking e Relacionamento',
    description: 'Fortaleça conexões profissionais.',
    color: '#44A6FF',
    createdAt: now,
    updatedAt: now
  },
];
